module.exports = __webpack_public_path__ + "static/media/hands_08.9338c691.svg";